import type { Bonus, PreviewPage, Volume } from '../types/content';
export const volumes: Volume[] = [{
  label: 'VOLUMEN 01',
  title: 'PLAN DE 30 DÍAS DE CUIDADOS',
  subtitle: 'ORGANIZÁ CADA JORNADA',
  items: ['30 jornadas preparadas con rutinas para cada momento del día.', 'Secuencias listas para usar, sin planificar desde cero.', '3 modelos familiares y 4 planes alternativos para organizarte mejor.'],
  result: '“Sé por dónde empezar cada día, con menos improvisación.”',
  accent: 'info'
}, {
  label: 'VOLUMEN 02',
  title: 'MANUAL VISUAL DE HIGIENE Y CONFORT',
  subtitle: 'TENÉ LOS CUIDADOS COTIDIANOS MÁS CLAROS',
  items: ['12 procedimientos visuales de higiene cotidiana.', 'Materiales, pasos y precauciones fáciles de consultar.', 'Recursos para piel, textiles y confort de tu familiar.'],
  result: '“Tengo una guía clara para organizar la higiene y el confort.”',
  accent: 'primary'
}, {
  label: 'VOLUMEN 03',
  title: 'MANUAL DE SEGURIDAD PARA CUIDADORES',
  subtitle: 'SABÉ CUÁNDO PEDIR AYUDA',
  items: ['8 posibles emergencias y 10 situaciones de consulta profesional.', '8 protocolos de orientación inicial ante señales preocupantes.', 'Recursos de prevención y seguridad para el día a día.'],
  result: '“Reconozco señales de alerta y sé cuándo pedir ayuda.”',
  accent: 'highlight'
}, {
  label: 'VOLUMEN 04',
  title: '60 ACTIVIDADES DE COMPAÑÍA Y ESTIMULACIÓN',
  subtitle: 'COMPARTÍ MOMENTOS SIN INVENTAR ACTIVIDADES',
  items: ['60 actividades preparadas de recuerdos, música y conversación.', 'Momentos de compañía listos para compartir, sin inventar ideas.', 'Pasos y adaptaciones según las posibilidades de tu familiar.'],
  result: '“Tengo actividades listas para compartir momentos agradables.”',
  accent: 'danger'
}];
export const previewPages: PreviewPage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/okcJEN3kwzTt5VjEUz5gT5/1.webp',
  alt: 'Portada del Volumen 01: Plan de 30 días de cuidados.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5yxRkW575B4uBJmcmMcrM7/2.webp',
  alt: 'Página del kit: Día 06, cerrar el día sin pendientes organizativos.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/sxyzgzqJFu1KFxRRfVRCCi/3.webp',
  alt: 'Página del kit: Día 13, comunicarse durante los cuidados.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/earggqar7Jd2W2s6ZTQUk6/4.webp',
  alt: 'Página del kit: Día 25, incluir momentos de compañía.'
}];
export const bonuses: Bonus[] = [{
  number: '01',
  title: 'GUÍA DE ORGANIZACIÓN DEL ESPACIO DE CUIDADOS',
  items: ['3 modelos de habitaciones y 6 zonas organizadas.', 'Listas de materiales listas para usar.', 'Espacios más ordenados, con todo a mano.'],
  value: '$12.000'
}, {
  number: '02',
  title: '35 MENSAJES PARA COORDINAR LA AYUDA FAMILIAR',
  items: ['35 mensajes de WhatsApp ya redactados.', 'Textos listos para copiar y pedir ayuda.', 'Coordiná relevos y tareas sin empezar de cero.'],
  value: '$10.000'
}, {
  number: '03',
  title: 'PLAN DE AUTOCUIDADO DE 7 DÍAS',
  items: ['7 jornadas de autocuidado preparadas.', '4 protocolos de pausas breves.', 'Rutinas para tu bienestar, cuando sea seguro descansar.'],
  value: '$9.000'
}, {
  number: '04',
  title: '12 GUIONES PARA CONSULTAS DE SALUD',
  items: ['12 guiones con preguntas ya preparadas.', 'Conversaciones de ejemplo para aclarar dudas.', 'Consultas más organizadas y claras.'],
  value: '$11.000'
}, {
  number: '05',
  title: '20 GUÍAS PARA SITUACIONES DIFÍCILES DEL CUIDADO',
  items: ['20 situaciones con respuestas preparadas.', 'Frases listas para usar en momentos difíciles.', 'Comunicación más clara y respetuosa.'],
  value: '$10.000'
}];
